import React from 'react';
import { ArrowDownCircle, ArrowUpCircle, X } from 'lucide-react';

export function MovimientoBottomSheet({ isOpen, onClose, onSelectMovimiento }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50">
      {/* Overlay */}
      <div 
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 bg-white dark:bg-gray-800 rounded-t-xl">
        <div className="p-4 space-y-4">
          {/* Header */}
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
              Registrar Movimiento
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full"
            >
              <X className="w-5 h-5 text-gray-500 dark:text-gray-400" />
            </button>
          </div>

          {/* Options */}
          <div className="grid grid-cols-2 gap-4">
            <button
              onClick={() => onSelectMovimiento('ingreso')}
              className="p-4 bg-white dark:bg-gray-700 rounded-xl border-2 border-green-500 dark:border-green-600 hover:bg-green-50 dark:hover:bg-green-900/20 transition-colors flex flex-col items-center gap-2"
            >
              <ArrowDownCircle className="w-8 h-8 text-green-500 dark:text-green-400" />
              <span className="font-medium text-green-600 dark:text-green-400">
                Ingreso de Dinero
              </span>
            </button>

            <button
              onClick={() => onSelectMovimiento('salida')}
              className="p-4 bg-white dark:bg-gray-700 rounded-xl border-2 border-red-500 dark:border-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors flex flex-col items-center gap-2"
            >
              <ArrowUpCircle className="w-8 h-8 text-red-500 dark:text-red-400" />
              <span className="font-medium text-red-600 dark:text-red-400">
                Salida de Dinero
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 